import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right-arrow",
  "use": "icon-right-arrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-right-arrow\"><defs><style type=\"text/css\"></style></defs><path d=\"M329.525 170.21366667l56.285-58.261 393.996 392.021-393.996 392.021-56.285-58.261 331.786-333.761z\" p-id=\"4795\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol